import { ActionCreatorWithoutPayload } from '@reduxjs/toolkit';

import { useAppDispatch } from '../../../../../../../store/hooks';

export const useToggleFormVisibility = (
  onToggleForm?: ActionCreatorWithoutPayload,
  changeFormState?: (state: boolean | ((prevState: boolean) => boolean)) => void
): (() => void) => {
  const dispatch = useAppDispatch();
  return () => {
    if (onToggleForm) {
      dispatch(onToggleForm());
    }

    changeFormState?.(prevState => !prevState);
  };
};
